const Divider = ({ additionalClassName, bgColor, hideOnDesktop, dashed }) => {
  return (
    <div
      className={`block ${additionalClassName} ${bgColor}  ${dashed ? 'border-t-[1px] border-dashed' : ''} ${hideOnDesktop ? 'lg:hidden' : ''}`}
      role="separator"
    />
  );
};

Divider.defaultProps = {
  additionalClassName: '',
  bgColor: 'bg-reliableBlack5',
  hideOnDesktop: false,
  dashed: false,
};

export default Divider;
